import { Box, Header, Heading, Text } from 'grommet';

const About = () => {
    return (
        <Box gap='medium' alignSelf='center' pad={{ top: 'large' }}>
            <Header
                direction="column"
                align='start'
                gap='xxsmall'
                pad={{ horizontal: 'xsmall' }}
            >
                <Heading level={2} margin="none">
                    About claim3
                </Heading>
                <Box width={{max: 'large'}} pad={{top: 'small'}}>
                    <Text>
                        The claim3 platform aims to prevent unauthorized use and distribution of copyrighted content, providing content creators with a robust tool for protecting their intellectual property.
                    </Text>
                </Box>
            </Header>
        </Box>
    )
}

export default About;